import React from 'react';
import sanerIcon from '../../../../assets/img/desktop/saner-logo.png';
import secpodLogo from '../../../../assets/img/desktop/secpod-logo.png';
import './CDGestionVulnerabilidades.css';

function CDGestionVulnerabilidades() {

    return (
        <main id="CDGestionVulnerabilidades">
            <section id="CDGV-c1">
                <h2>Gestión de Vulnerabilidades</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Ciberseguridad</li>
                    <li>/</li>
                    <li>Gestión de Vulnerabilidades</li>
                </ul>
            </section>
            <section id="CDGV-c2">
                <div id="CDGV-c2__text">
                    <h1>Gestión Continua de Vulnerabilidades y Exposición</h1>
                    <p>Detecte, defienda y derrote vulnerabilidades de principio a fin. Logre una reducción completa de la superficie de ataque con una gestión de riesgos inteligente, rápida y eficiente. La seguridad proactiva comienza aquí.</p>
                </div>
            </section>
            <section id="CDGV-c3">
                <div className="CDGV-service-card">
                    <div className="CDGV-service-card__icon">
                        <img src={sanerIcon} alt="Saner CVEM Icon" />
                    </div>
                    <h3>Saner CVEM</h3>
                    <p>Saner Continuous Vulnerability & Exposure Management (CVEM) es una plataforma unificada diseñada para empresas modernas que combate el creciente panorama de riesgos con capacidades avanzadas para escanear, evaluar, priorizar y remediar vulnerabilidades en dispositivos. La plataforma gestiona vulnerabilidades, exposiciones y otros riesgos de seguridad en una única consola unificada, utilizando un feed SCAP propio con más de 190,000 verificaciones de riesgo actualizadas diariamente. Saner CVEM ofrece mitigación de vulnerabilidades a tiempo con remediación integrada, permitiendo evaluar y corregir vulnerabilidades desde una sola consola mediante parches y otros controles de seguridad. La plataforma automatiza todas las tareas desde el escaneo hasta la remediación, estableciendo una rutina continua para gestionar vulnerabilidades y riesgos de seguridad. Con soporte para múltiples plataformas (Windows, macOS, Linux) y más de 550 aplicaciones de terceros, Saner CVEM proporciona gestión de parches automatizada, cumplimiento normativo, priorización de riesgos basada en contexto empresarial y visibilidad holística de TI para detectar anomalías de manera efectiva.</p>
                    <div className="CDGV-service-card__features">
                        <h4>Características principales:</h4>
                        <ul>
                            <li>Base de datos de vulnerabilidades con más de 190,000 verificaciones de seguridad</li>
                            <li>Gestión de parches automatizada para sistemas operativos y aplicaciones de terceros</li>
                            <li>Priorización de riesgos basada en contexto empresarial y marco SSVC</li>
                            <li>Cumplimiento normativo y gestión de configuración</li>
                            <li>Escaneo continuo y remediación integrada</li>
                            <li>Visibilidad completa de activos IT y normalización</li>
                            <li>Gestión de endpoints y endurecimiento de dispositivos</li>
                        </ul>
                    </div>
                    <div className="CDGV-service-card__logo">
                        <img src={secpodLogo} alt="SecPod Logo" />
                    </div>
                </div>
            </section>
        </main>
    );
}

export default CDGestionVulnerabilidades;

